import React, { Component } from "react";
import { connect } from "react-redux";
import { getByID, update } from "../../store/ducks/voucher/actions";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import { filterErrorHandler, formValidation } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
// import moment from "moment";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import Skeleton from "react-loading-skeleton";
import Select from "../../components/Input/Select/Select";
import Select2 from "../../components/Input/Select2/Select2";
import DateTimePicker from '../../components/DateTimePicker/DateTimePicker';

class VoucherEdit extends Component {
    constructor(props) {
        const { t } = props;

        super(props);
        this.state = {
            code: "",
            amount: "",
            type: "",
            turnover: 0,
            status: 1,
            set_group: 0,
            start_date: '',//moment().format("YYYY-MM-DD")+" 00:00:00",
            end_date: '',//moment().format("YYYY-MM-DD")+" 00:00:00",
            error_message: [],
            touched: false,
            voucherType: [
                {
                    label: t('voucher.amount'),
                    value: 'amount'
                },
                {
                    label: t('voucher.percentage'),
                    value: 'percentage'
                }
            ],
            voucherCategory: [
                {
                    label: t('voucher.deposit'),
                    value: 'deposit'
                },
                {
                    label: t('voucher.redemption'),
                    value: 'redemption'
                }
            ],
            statusOptions: [
                {
                    label: t('global.active'),
                    value: 1
                },
                {
                    label: t('global.inactive'),
                    value: 0
                }
            ],
            yesNoOptions: [
                {
                    label: t('voucher.no'),
                    value: 0
                },
                {
                    label: t('voucher.yes'),
                    value: 1
                }
            ],
            selectedGroupMember: [],
            showMaxCap: false,
            max_cap: 0,
            showVoucherType: false,
            voucher_list: [{ listIndex: Math.random(), code: "", id: ""}],
            limit: "",
            batch_no: "",
            claim_limit: "",
            min_deposit: "",
            number_of_rounds: 10,
            bet_scale: 0.01,
            number_of_valid_days: 1,
            game_codes: [],
            showFreeBetsFields: false,
            gameListOptions: [
                { value: 'vs20starlightx', label: 'Starlight Princess 1000' },
                { value: 'vs20olympx', label: 'Gates of Olympus 1000' },
                { value: 'vs20gatotx', label: 'Gates of Gatot Kaca 1000' },
                { value: 'vs20sugarrushx', label: 'Sugar Rush 1000' },
                { value: 'vs20fruitswx', label: 'Sweet Bonanza 1000' }
            ]
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleGameListChange = this.handleGameListChange.bind(this);
    }

    componentDidMount() {
        formValidation("voucher_form");
        
        let params = {};
        params.id = this.props.voucherID;
        this.props.getByID(params);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.edit !== undefined && nextProps.edit !== this.props.edit) {
            if(nextProps.edit.responseCode === 200 && nextProps.edit.msgType === 'success'){
                let voucherList = [];

                nextProps.edit.data.voucherCodeData.map((item, idx) => {
                    return voucherList.push({ listIndex: Math.random(), code: item.code, id: item.id });
                })
    
                this.setState({
                    batch_no: nextProps.edit.data.voucherData.batch_no,
                    code: nextProps.edit.data.voucherCodeData,
                    amount: nextProps.edit.data.voucherData.amount,
                    category: nextProps.edit.data.voucherData.category,
                    type: nextProps.edit.data.voucherData.type,
                    max_cap: nextProps.edit.data.voucherData.max_cap,
                    limit: nextProps.edit.data.voucherData.limit,
                    turnover: nextProps.edit.data.voucherData.turnover,
                    status: nextProps.edit.data.voucherData.status,
                    start_date: nextProps.edit.data.voucherData.start_date,
                    end_date: nextProps.edit.data.voucherData.end_date,
                    loading: false,
                    showVoucherType: !!(nextProps.edit.data.voucherData.category) ? true : false,
                    showMaxCap: nextProps.edit.data.voucherData.type === "percentage" ? true : false,
                    showFreeBetsFields: nextProps.edit.data.voucherData.type === "free_bets" ? true : false,
                    voucherType: nextProps.edit.data.voucherData.category === 'deposit' ?
                        [{label: t('voucher.percentage'),value: 'percentage'}, {label: t('voucher.free_bets'),value: 'free_bets'}] :
                        [{label: t('voucher.amount'),value: 'amount'}],
                    voucher_list: voucherList,
                    claim_limit: nextProps.edit.data.voucherData.claim_limit,
                    min_deposit: nextProps.edit.data.voucherData.min_deposit,
                    number_of_rounds: nextProps.edit.data.voucherData.number_of_rounds || 0,
                    bet_scale: nextProps.edit.data.voucherData.bet_scale || 0,
                    number_of_valid_days: nextProps.edit.data.voucherData.number_of_valid_days || 0,
                    game_codes: (() => {
                        const gameCodes = nextProps.edit.data.voucherData.game_codes;
                        if (!gameCodes) return [];
                        if (Array.isArray(gameCodes)) return gameCodes;
                        if (typeof gameCodes === 'string') {
                            // Try parsing as JSON first
                            try {
                                const parsed = JSON.parse(gameCodes);
                                return Array.isArray(parsed) ? parsed : [];
                            } catch (e) {
                                // If JSON parsing fails, try comma-separated string
                                if (gameCodes.includes(',')) {
                                    return gameCodes.split(',').map(code => code.trim()).filter(Boolean);
                                }
                                // Single value
                                return gameCodes.trim() ? [gameCodes.trim()] : [];
                            }
                        }
                        return [];
                    })()
                });
            }else{
                this.setState({
                    loading: true,
                }, () => {
                    filterErrorHandler(nextProps.edit.message);
                });
                Swal.close();
            }
        }

        if (nextProps.updateRs !== this.props.updateRs && nextProps.updateRs !== undefined) {
            if (nextProps.updateRs.responseCode === 200 && nextProps.updateRs.msgType === 'success') {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-updated"),
                    icon: nextProps.updateRs.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } else {
                this.setState({
                    loading: false,
                    touched: true,
                    error_message: nextProps.updateRs.message,
                });
                Swal.close();
            }
        }
        return true;
    }

    updateHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.update"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let value_array = [];

                this.state.voucher_list.forEach((item, idx) => {
                    value_array.push({
                        code: item.code,
                        id: item.id
                    })
                })


                let updateData = {};
                updateData.id = this.props.voucherID;
                updateData.code = value_array;
                updateData.amount = this.state.type === "free_bets" ? 0 : this.state.amount;
                updateData.category = this.state.category;
                updateData.type = this.state.type;
                updateData.max_cap = this.state.max_cap;
                updateData.turnover = this.state.turnover;
                updateData.status = this.state.status;
                updateData.start_date = this.state.start_date;
                updateData.end_date = this.state.end_date;
                if(this.state.limit !== ""){
                    updateData.limit = this.state.limit;
                }
                if(this.state.claim_limit !== ""){
                    updateData.claim_limit = this.state.claim_limit;
                }

                if(this.state.min_deposit !== ""){
                    updateData.min_deposit = this.state.min_deposit;
                }

                if(this.state.type === "free_bets"){
                    updateData.number_of_rounds = this.state.number_of_rounds;
                    updateData.bet_scale = this.state.bet_scale;
                    updateData.number_of_valid_days = this.state.number_of_valid_days;
                    updateData.game_codes = this.state.game_codes;
                }

                updateData.batch_no = this.state.batch_no;
                this.props.update(updateData);
            }
        });
    };

    handleChange = (event) => {
        const { t } = this.props;

        // if (event.target.name === 'start_date' || event.target.name === 'end_date') {
        //     event.target.value = moment(event.target.value).format("YYYY-MM-DD HH:mm:ss");
        // }
        
        if (event.target.name === 'code') {
            event.target.value = event.target.value.toUpperCase();
        }

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'type') {
            if (event.target.value === "percentage") {
                this.setState({
                    showMaxCap: true,
                    showFreeBetsFields: false
                });
            } else if (event.target.value === "free_bets") {
                this.setState({
                    showMaxCap: false,
                    showFreeBetsFields: true
                });
            } else {
                this.setState({
                    showMaxCap: false,
                    showFreeBetsFields: false
                });
            }
        }
        
        if (event.target.name === 'category') {
            if (event.target.value === "deposit") {
                this.setState({
                    voucherType: [
                        {
                            label: t('voucher.percentage'),
                            value: 'percentage'
                        },
                        {
                            label: t('voucher.free_bets'),
                            value: 'free_bets'
                        }
                    ],
                    showVoucherType: true,
                    showMaxCap: true,
                    type: "percentage"
                });
            } else if (event.target.value === "redemption") {
                this.setState({
                    voucherType: [
                        {
                            label: t('voucher.amount'),
                            value: 'amount'
                        }
                    ],
                    showVoucherType: true,
                    showMaxCap: false,
                    type: "amount",
                    min_deposit: "",
                    max_cap: 0
                });
            } else {
                this.setState({
                    showVoucherType: false,
                    showMaxCap: false,
                    type: "",
                    min_deposit: "",
                    max_cap: 0
                });
            }
        }
    };

    handleGameListChange = (event) => {
        // Extract only the values from the selected options
        const gameCodes = event ? event.map(item => item.value) : [];
        this.setState({
            game_codes: gameCodes
        });
    };

    handleSettingListChange = (event, idx) => {
        let voucher_list = [...this.state.voucher_list];
        voucher_list[event.target.dataset.id][event.target.name] = event.target.value;
        this.setState({ voucher_list });
    }

    removeRecord = (i) => {
        // const list = [...this.state.setting_list];
        // list.splice(idx, 1);
        // this.setState({setting_list: list});
        this.setState({
            voucher_list: this.state.voucher_list.filter((item, idx) => i !== idx)
        })
    }

    render() {
        const { t } = this.props;
        let display = null;
        if (!this.state.loading && this.state.code !== "") {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("voucher.edit_voucher")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                <form method="post" id="voucher_form" className="form-horizontal" onSubmit={this.updateHandler} noValidate>
                                    <ValidationError formName="voucher_form" touched={this.state.touched} message={this.state.error_message} />
                                    <div className="row">
                                    <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="batch_no">{t("voucher.batch-no")}</label>
                                                <StringInput
                                                    id="batch_no"
                                                    name="batch_no"
                                                    className="form-control"
                                                    placeholder={t("voucher.batch-no")}
                                                    value={this.state.batch_no}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="limit">{t("voucher.voucher-limit")} ({t("voucher.voucher-limit-remark")})</label>
                                                <StringInput
                                                    id="limit"
                                                    name="limit"
                                                    className="form-control"
                                                    placeholder={t("voucher.voucher-limit")}
                                                    value={this.state.limit}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="code">{t("voucher.claim-limit")}</label>
                                                <StringInput
                                                    id="claim_limit"
                                                    name="claim_limit"
                                                    className="form-control"
                                                    placeholder={t("voucher.claim-limit")}
                                                    value={this.state.claim_limit}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    autocapitalize="on"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="category">{t("voucher.category")}</label>
                                                <Select
                                                    id="category"
                                                    name="category"
                                                    className="form-control"
                                                    onChange={this.handleChange}
                                                    options={this.state.voucherCategory}
                                                    emptyValue={false}
                                                    value={this.state.category}
                                                />
                                            </div>
                                        </div>
                                        {this.state.showVoucherType === true && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="type">{t("voucher.type")}</label>
                                                    <Select
                                                        id="type"
                                                        name="type"
                                                        className="form-control"
                                                        onChange={this.handleChange}
                                                        options={this.state.voucherType}
                                                        emptyValue={false}
                                                        value={this.state.type}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(!!(this.state.type) && this.state.type !== 'free_bets' && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="amount">{this.state.type === 'amount' ? t("voucher.amount") : t("voucher.percentage")}</label>
                                                    <StringInput
                                                        id="amount"
                                                        name="amount"
                                                        className="form-control"
                                                        placeholder={this.state.type === 'amount' ? t("voucher.amount") : t("voucher.percentage")}
                                                        type="number"
                                                        value={this.state.amount}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {this.state.showMaxCap === true && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="max_cap">{t("voucher.max_cap")}</label>
                                                    <StringInput
                                                        id="max_cap"
                                                        name="max_cap"
                                                        className="form-control"
                                                        placeholder={t("voucher.max_cap")}
                                                        value={this.state.max_cap}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(this.state.category === 'deposit' && (this.state.type === 'percentage' || this.state.type === 'free_bets')) && (
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="min_deposit">{t("voucher.min-deposit")}</label>
                                                    <StringInput
                                                        id="min_deposit"
                                                        name="min_deposit"
                                                        className="form-control"
                                                        placeholder={t("voucher.min-deposit")}
                                                        value={this.state.min_deposit}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="turnover">
                                                    {this.state.category === 'deposit' && this.state.type === 'free_bets'
                                                        ? t("voucher.turnover-fixed")
                                                        : t("voucher.turnover-multiplier")}
                                                </label>
                                                <StringInput
                                                    id="turnover"
                                                    name="turnover"
                                                    className="form-control"
                                                    placeholder={t("voucher.turnover")}
                                                    value={this.state.turnover}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {this.state.showFreeBetsFields === true && (
                                            <>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="number_of_rounds">{t("voucher.free_round")}</label>
                                                        <StringInput
                                                            id="number_of_rounds"
                                                            name="number_of_rounds"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.free_round")}
                                                            value={this.state.number_of_rounds}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="bet_scale">{t("voucher.bet_scale")}</label>
                                                        <StringInput
                                                            id="bet_scale"
                                                            name="bet_scale"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.bet_scale")}
                                                            value={this.state.bet_scale}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="number_of_valid_days">{t("voucher.valid_period_days")}</label>
                                                        <StringInput
                                                            id="number_of_valid_days"
                                                            name="number_of_valid_days"
                                                            className="form-control"
                                                            type="number"
                                                            placeholder={t("voucher.valid_period_days")}
                                                            value={this.state.number_of_valid_days}
                                                            onChange={this.handleChange}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="game_codes">{t("voucher.game_list")}</label>
                                                        <Select2
                                                            id="game_codes"
                                                            name="game_codes"
                                                            className="form-control"
                                                            options={this.state.gameListOptions}
                                                            onChange={this.handleGameListChange}
                                                            value={this.state.game_codes.map(code =>
                                                                this.state.gameListOptions.find(opt => opt.value === code)
                                                            ).filter(Boolean)}
                                                            placeholder={t("global.select")}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="status">{t("voucher.status")}</label>
                                                <Select
                                                    id="status"
                                                    name="status"
                                                    className="form-control"
                                                    onChange={this.handleChange}
                                                    options={this.state.statusOptions}
                                                    emptyValue={false}
                                                    value={this.state.status}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="start_date">{t("voucher.start_date")}</label>
                                                <DateTimePicker
                                                    id='start_date'
                                                    name='start_date'
                                                    className='form-control filter-input'
                                                    singleDatePicker={true}
                                                    timePicker={true}
                                                    value={this.state.start_date}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="end_date">{t("voucher.end_date")}</label>
                                                <DateTimePicker
                                                    id='end_date'
                                                    name='end_date'
                                                    className='form-control filter-input'
                                                    singleDatePicker={true}
                                                    timePicker={true}
                                                    value={this.state.end_date}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ overflowY: 'auto' }}>
                                                <table className="table" id="setting_table" style={{ minWidth: 500 }}>
                                                    <thead className="text-center">
                                                        <tr>
                                                            <th className="p-2">{t("global.no")}</th>
                                                            <th className="">{t("voucher.code")}</th>
                                                            <th style={{ width: "5%" }} />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.voucher_list.map((item, idx) => {
                                                            return (
                                                                <tr key={idx} className="text-center">
                                                                    <td>{idx + 1}</td>
                                                                    <td key={`key-${idx}`}>
                                                                        <input
                                                                            id="code"
                                                                            name="code"
                                                                            data-id={idx}
                                                                            className="form-control"
                                                                            placeholder={t("voucher.code")}
                                                                            value={item.code}
                                                                            onChange={this.handleSettingListChange}
                                                                            autoComplete="off"
                                                                            disabled={true}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        {/* <i className="fa fa-trash" style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.removeRecord(idx)}></i> */}
                                                                        {/* <button type="button" name="remove" className="remove btn btn-sm btn-white delete" onClick={() => this.removeRecord(idx)}>
                                                                            <i className="fa fa-trash"></i>
                                                                        </button> */}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>

                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("voucher.edit_voucher")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                {this.state.loading === true ? <Skeleton count={4} /> : <ValidationError formName="voucher_form" touched={this.state.touched} message={this.state.error_message} /> }
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("voucher.voucher")}</h4>
                        </div>
                    </div>
                </div>
                {display}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        edit: state.voucher.edit,
        updateRs: state.voucher.update,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getByID: (data) => dispatch(getByID(data)),
        update: (data) => dispatch(update(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(VoucherEdit));
